(function () {
  // Only run on product pages
  if (!window.location.pathname.startsWith('/products/')) return;

  // Prevent duplicate injection
  if (document.querySelector('script[data-product-schema]')) return;

  // Shopify product data (Dawn exposes this)
  var productData =
    window.ShopifyAnalytics &&
    window.ShopifyAnalytics.meta &&
    window.ShopifyAnalytics.meta.product;

  if (!productData || !productData.variants || !productData.variants.length) return;

  // Determine selected variant (fallback to first)
  var variant =
    productData.variants.find(function (v) {
      return v.id === productData.selectedVariantId;
    }) || productData.variants[0];

  // Judge.me product-specific review data (if loaded)
  var ratingValue = null;
  var reviewCount = null;

  if (window.jdgmProductData) {
    ratingValue = window.jdgmProductData.rating;
    reviewCount = window.jdgmProductData.reviewCount;
  }

  var productSchema = {
    "@context": "https://schema.org",
    "@type": "Product",
    "@id": window.location.origin + window.location.pathname,
    "name": productData.title,
    "url": window.location.href,
    "image": productData.images,
    "description": productData.description,
    "brand": {
      "@type": "Brand",
      "name": productData.vendor || "ALIIS"
    },
    "offers": {
      "@type": "Offer",
      "url": window.location.href,
      "priceCurrency": productData.currency,
      "price": (variant.price / 100).toFixed(2),
      "availability": variant.available
        ? "https://schema.org/InStock"
        : "https://schema.org/OutOfStock",
      "itemCondition": "https://schema.org/NewCondition"
    }
  };

  // Attach reviews ONLY if they exist for this product
  if (ratingValue && reviewCount) {
    productSchema.aggregateRating = {
      "@type": "AggregateRating",
      "ratingValue": ratingValue.toString(),
      "reviewCount": reviewCount.toString()
    };
  }

  var script = document.createElement('script');
  script.type = 'application/ld+json';
  script.textContent = JSON.stringify(productSchema);
  script.setAttribute('data-product-schema', 'true');

  document.head.appendChild(script);
})();